import * as React from 'react';
import { cx } from '../../../components/CareerLayout/styles';

export const About: React.FC = () => (
  <section id="about" className={cx('main_section_about')}>
    <div className={cx('padding-global padding-section-medium')}>
      <div className={cx('container-large')}>
        <div className={cx('main_content_about')}>
          <h2>
            {'Новая жизнь '}
            <br />
            <span className={cx('text-color-brand-green')}>{'начинается'}</span>
            <br />
            {'с нас'}
          </h2>
          <div className={cx('spacer-large')}></div>
          <div className={cx('main_about_content-grid')}>
            <div className={cx('main_about_tablet-spacer-wrapper layout0')}>
              <div className={cx('text-size-large')}>
                {
                  'К нам приходят, чтобы исполнить мечту: снять первую в жизни квартиру, расширить метры для семьи, построить дом и посадить дерево, бросить всё и уехать к морю.'
                }
              </div>
              <div className={cx('spacer-small show-tablet')}></div>
            </div>
            <div className={cx('main_about_card is-accent layout1')}>
              <div className={cx('text-size-huge text-style-uppercase text-color-brand-blue')}>{'топ 15'}</div>
              <div>
                {'сервисов '}
                <br />
                {'по недвижимости в мире'}
              </div>
            </div>
            <div className={cx('main_about_card layout2')}>
              <div className={cx('text-size-huge text-style-uppercase text-color-brand-blue')}>{'20+ млн'}</div>
              <div>{'пользователей в месяц (каждый 7й житель России)'}</div>
            </div>
            <div className={cx('main_about_card is-accent is-reverse-mobile layout3')}>
              <div className={cx('text-size-huge text-style-uppercase text-color-brand-blue')}>{'30+'}</div>
              <div>{'продуктовых команд '}</div>
            </div>
            <div className={cx('main_about_card is-reverse-mobile layout4')}>
              <div className={cx('text-size-huge text-style-uppercase text-color-brand-blue')}>{'2+ млн'}</div>
              <div>{'активных объявлений'}</div>
            </div>
            <div className={cx('main_about_card is-reverse-mobile layout5')}>
              <div className={cx('text-size-huge text-style-uppercase text-color-brand-blue')}>{'99%'}</div>
              <div>{'контента проверено с помощью ИИ'}</div>
            </div>
            <div className={cx('main_about_card layout6')}>
              <div className={cx('text-size-huge text-style-uppercase text-color-brand-blue')}>{'1000+'}</div>
              <div>{'сотрудников '}</div>
            </div>
            <div className={cx('main_about_card is-accent is-reverse-mobile layout7')}>
              <div className={cx('text-size-huge text-style-uppercase text-color-brand-blue')}>{'14,8%'}</div>
              <div>{'семей нашли жильё у нас '}</div>
            </div>
            <div className={cx('main_about_card is-reverse-mobile layout8')}>
              <div className={cx('text-size-huge text-style-uppercase text-color-brand-blue')}>{'16%'}</div>
              <div>{'рынка больших данных принадлежит нам '}</div>
            </div>
            <div className={cx('main_about_card is-reverse-mobile layout9')}>
              <div className={cx('text-size-huge text-style-uppercase text-color-brand-blue')}>{'3'}</div>
              <div>{'офиса '}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);
